import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [kullanici, setKullanici] = useState(null);
  const [yetkiler, setYetkiler] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('otoflow_token');
    const kullaniciBilgi = localStorage.getItem('otoflow_kullanici');
    const yetkiBilgi = localStorage.getItem('otoflow_yetkiler');
    if (token && kullaniciBilgi) {
      try {
        const k = JSON.parse(kullaniciBilgi);
        setKullanici(k);
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        if (yetkiBilgi) setYetkiler(JSON.parse(yetkiBilgi));
        api.get('/yetkiler/me').then(({ data }) => {
          setYetkiler(data.map || {});
          localStorage.setItem('otoflow_yetkiler', JSON.stringify(data.map || {}));
        }).catch(() => {
          setYetkiler({});
        });
      } catch {
        localStorage.removeItem('otoflow_token');
        localStorage.removeItem('otoflow_kullanici');
        localStorage.removeItem('otoflow_yetkiler');
      }
    }
    setYukleniyor(false);
  }, []);

  const girisYap = async (kullanici_adi, sifre) => {
    const { data } = await api.post('/auth/login', {
      kul_adi: kullanici_adi,
      sifre
    });
    const { token, kullanici: k } = data;
    localStorage.setItem('otoflow_token', token);
    localStorage.setItem('otoflow_kullanici', JSON.stringify(k));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setKullanici(k);
    try {
      const y = await api.get('/yetkiler/me');
      setYetkiler(y.data.map || {});
      localStorage.setItem('otoflow_yetkiler', JSON.stringify(y.data.map || {}));
    } catch {
      setYetkiler({});
    }
    return k;
  };

  const cikisYap = () => {
    localStorage.removeItem('otoflow_token');
    localStorage.removeItem('otoflow_kullanici');
    localStorage.removeItem('otoflow_yetkiler');
    delete api.defaults.headers.common['Authorization'];
    setKullanici(null);
    setYetkiler(null);
  };

  const ROL_YETKILER = {
    yonetici: {
      muhasebe:true, finans:true, arsiv:true, satinalma:true,
      kullanicilar:true, roller:true, belgeler:true, ekspetriz:true,
      fotograflar:true, eksper:true, sigorta:true, mesajlar:true, dosya_yetkilendirme:true,
      lokasyon:true, lokasyon_tumu:true, arac_ekle:true, ihale:true,
      arac_listesi:true,
    },
    muhasebe: {
      muhasebe:true, finans:true, arsiv:true,
      belgeler:true, ekspetriz:true, fotograflar:true,
      eksper:true, sigorta:true, mesajlar:true,
      lokasyon:true, lokasyon_tumu:true, arac_listesi:true,
    },
    tamirci: {
      belgeler:true, ekspetriz:true, fotograflar:true,
      eksper:true, sigorta:true, mesajlar:true,
      lokasyon:true, arac_ekle:true, arac_listesi:true,
      siparis_ver:true,
    },
    mudur: {
      muhasebe:true, arsiv:true, ihale:true,
      belgeler:true, ekspetriz:true, fotograflar:true,
      eksper:true, sigorta:true, mesajlar:true,
      lokasyon:true, lokasyon_tumu:true, arac_listesi:true,
    },
    frenusta: {
      ihale:true, ihale_fiyatsiz:true,
      mesajlar:true,
    },
    onay_mercii: {
      ihale:true, ihale_fiyatsiz:true, ihale_onay:true,
    },
    hakedis: {
      ihale:true, ihale_hakedis:true,
    },
  };

  const normalizeYetkiKey = (key) => {
    const raw = String(key || '').trim().toLocaleLowerCase('tr-TR');
    if (raw === 'ekspertiz') return 'ekspetriz';
    return raw;
  };

  const canGor = (key) => {
    if (!kullanici) return false;
    const k = normalizeYetkiKey(key);
    const rol = kullanici.rol;
    if (rol === 'yonetici') return true;
    const rolYetki = ROL_YETKILER[rol];
    if (rolYetki) return !!rolYetki[k];
    if (yetkiler && Object.keys(yetkiler).length > 0) {
      if (yetkiler[k] === undefined) return false;
      return !!yetkiler[k]?.gor;
    }
    return false;
  };

  const canDuzenle = (key) => {
    if (!kullanici) return false;
    const k = normalizeYetkiKey(key);
    const rol = kullanici.rol;
    if (rol === 'yonetici') return true;
    const rolYetki = ROL_YETKILER[rol];
    if (rolYetki) return !!rolYetki[k];
    if (yetkiler && Object.keys(yetkiler).length > 0) {
      if (yetkiler[k] === undefined) return false;
      return !!yetkiler[k]?.duzenle;
    }
    return false;
  };

  if (yukleniyor) {
    return (
      <div style={{
        display:'flex', alignItems:'center', justifyContent:'center',
        minHeight:'100vh', fontFamily:"'Barlow Condensed',sans-serif",
        fontSize:14, fontWeight:700, letterSpacing:2, textTransform:'uppercase', color:'#9c9189',
      }}>
        Yükleniyor...
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ kullanici, yetkiler, girisYap, cikisYap, canGor, canDuzenle }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
